import { LeftOutlined, RightOutlined, LayoutOutlined, BuildOutlined, TeamOutlined } from '@ant-design/icons'
import { Button, Menu } from 'antd'
import clsx from 'clsx'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import styles from './main.sidebar.module.scss'
import logo from '../../../assets/images/logo.png'
import { RouteEnum } from '../../../constants/routes.enum'

import type { MenuProps } from 'antd'

export const MainSidebar: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(true)

  type MenuItem = Required<MenuProps>['items'][number]

  const items: MenuItem[] = [
    {
      key: 'Workspace',
      label: t('workspace.header'),
      icon: <LayoutOutlined />,
      children: [
        {
          key: 'workspace',
          label: t('workspace.header'),
          onClick: () => navigate(`/workspace`),
        },
        {
          key: 'milestone',
          label: t('milestone.header'),
          onClick: () => navigate(`/workspace/milestones`),
        },
        {
          key: 'milestone-sequence',
          label: t('milestoneSequence.header'),
          onClick: () => navigate(`/workspace/milestones-sequence`),
        },
        {
          key: 'milestone-transfer',
          label: t('milestoneTransfer.header'),
          onClick: () => navigate(`/workspace/milestones-transfer`),
        },
      ],
    },
    {
      key: 'Objects',
      label: t('objectsPage.header'),
      icon: <BuildOutlined />,
      children: [
        {
          key: 'objects',
          label: t('objectsPage.header'),
          onClick: () => navigate(`/objects`),
        },
      ],
    },
    {
      key: 'Users',
      label: t('usersPage.header'),
      icon: <TeamOutlined />,
      children: [
        {
          key: 'users',
          label: t('usersPage.header'),
          onClick: () => navigate(`/users`),
        },
        {
          key: 'roles',
          label: t('usersPage.roles'),
          onClick: () => navigate(`/roles`),
        },
      ],
    },
  ]

  const toggleCollapsed = () => {
    setCollapsed(!collapsed)
  }

  const handleLogoClick = () => {
    navigate(RouteEnum.MAIN)
  }

  return (
    <div className={clsx(styles.sidebar)}>
      <div className="logo cursor-pointer">
        <img
          alt="Sios-logo"
          onClick={handleLogoClick}
          src={logo}
        />
      </div>
      <Menu
        className={clsx(styles.sidebarMenu, {
          [styles['sidebarMenu--collapsed']]: collapsed,
        })}
        defaultOpenKeys={['sub1']}
        defaultSelectedKeys={['1']}
        inlineCollapsed={collapsed}
        inlineIndent={16}
        items={items}
        mode="inline"
        theme="dark"
      />
      <Button
        className={clsx(styles.sidebarCollapseButton)}
        onClick={toggleCollapsed}
        block
      >
        {collapsed ? <RightOutlined /> : <LeftOutlined />}
      </Button>
    </div>
  )
}
